import { render, staticRenderFns } from "./file-preview.vue?vue&type=template&id=e63eeace"
import script from "./file-preview.vue?vue&type=script&lang=js"
export * from "./file-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports